<template>
  <el-dialog
    :visible="show"
    @close="closeDialog"
    @open="init"
    :close-on-click-modal="false"
    width="600px"
  >
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item
        :label="$t('text.actions')"
        prop="action"
        :label-width="formLabelWidth"
      >
        <el-select
          v-model="form.action"
          filterable
          :placeholder="$t('message.chooseOne')"
        >
          <el-option :label="$t('text.add')" value="ADD"></el-option>
          <el-option :label="$t('text.delete')" value="REMOVE"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
          :label="$t('text.payType')"
          prop="productId"
          :label-width="formLabelWidth"
      >
        <el-select
            v-model="form.productId"
            filterable
            :placeholder="$t('message.chooseOne')"
        >
          <el-option
              :label="$t('text.collection')"
              :value="PAYMENT_TYPE_ID_COLLECTION"
          ></el-option>
          <el-option
              :label="$t('text.disbursement')"
              :value="PAYMENT_TYPE_ID_PAYMENT"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
          :label="$t('text.channelType')"
          prop="channelType"
          :label-width="formLabelWidth"
      >
        <el-select
            v-model="form.channelType"
            filterable
            :placeholder="$t('message.chooseOne')"
        >
          <template v-if="this.$store.state.isPK && form.productId === PAYMENT_TYPE_ID_COLLECTION">
            <el-option v-for="(value, key) in paymentTypes.PK.PAYMENT"
                       :key="key"
                       :label="key"
                       :value="value"/>
          </template>
          <template v-if="this.$store.state.isPK && form.productId === PAYMENT_TYPE_ID_PAYMENT">
            <el-option v-for="(value, key) in paymentTypes.PK.TRANSFER"
                       :key="key"
                       :label="key"
                       :value="value"/>
          </template>
          <template v-if="this.$store.state.isBD && form.productId === PAYMENT_TYPE_ID_COLLECTION">
            <el-option v-for="(value, key) in paymentTypes.BD.PAYMENT"
                       :key="key"
                       :label="key"
                       :value="value"/>
          </template>
          <template v-if="this.$store.state.isBD && form.productId === PAYMENT_TYPE_ID_PAYMENT">
            <el-option v-for="(value, key) in paymentTypes.BD.TRANSFER"
                       :key="key"
                       :label="key"
                       :value="value"/>
          </template>
        </el-select>
      </el-form-item>

      <el-form-item
          :label="$t('text.channel')"
          :label-width="formLabelWidth"
          prop="channelIds"
      ><el-input
          v-model="form.channelIds"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="submit">{{ $t('text.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {PAYMENT_TYPE_ID_COLLECTION, PAYMENT_TYPE_ID_PAYMENT} from "@/utils/Constant";
import { PaymentType } from '@/constants/paymentTypes';

export default {
  name: "allRouteChannelUpdate",
  props: {
    show: Boolean
  },
  data() {
    return {
      PAYMENT_TYPE_ID_COLLECTION,
      PAYMENT_TYPE_ID_PAYMENT,
      paymentTypes: PaymentType,
      form: {
        action: "ADD",
        productId: PAYMENT_TYPE_ID_COLLECTION,
        channelType: "",
        channelIds: "",
      },
      formLabelWidth: "120px",
      rules: {
        action: [{ required: true, message: this.$t('message.chooseOne'), trigger: ["blur", "change"] }],
        productId: [{ required: true, message: this.$t('message.chooseOne'), trigger: ["blur", "change"] }],
        channelType: [{ required: true, message: this.$t('message.chooseOne'), trigger: ["blur", "change"] }],
        channelIds: [{ required: true, message: this.$t('message.channelIdRequiredError'), trigger: ["blur", "change"] }]
      }
    };
  },
  computed: {

  },
  methods: {
    init() {},
    closeDialog() {
      this.form = {
        action: "ADD",
        productId: PAYMENT_TYPE_ID_COLLECTION,
        channelType: "",
        channelIds: "",
      };
      this.$refs["form"].resetFields(); //关闭的时候重置表单
      this.$emit("update:show", false);
    },
    submit() {
      console.log(this.form);
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.axios
            .post("/routeConfigInfo/routeConfigInfoUpdateChannelAll", this.form)
            .then((res) => {
              if (res.code === 200) {
                this.$notify({
                  title: this.$t('text.prompt'),
                  message: res.msg,
                  type: "success"
                });

                this.$bus.$emit("refresh"); //通知刷新

                this.closeDialog();
              } else {
                this.$notify.error({
                  title: this.$t('text.prompt'),
                  message: res.msg
                });
              }
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
